export const maquetaTpl = {
  modalDatos: {
    regTitle: `Dettagli della registrazione`,
    paymentMethod: `Metodo di pagamento`,
    paymentDate: `Data di pagamento`,
    guestCount: `Numero di ospiti`,
    unspecified: `Non specificato`,
    pay: {
      DESTI: `Pagamento a destinazione`,
      EFECT: `Contanti`,
      MOVIL: `Pagamento da mobile`,
      OTRO: `Altri metodi di pagamento`,
      PLATF: `Piattaforma di pagamento`,
      TARJT: `Carta di credito`,
      TRANS: `Bonifico bancario`,
      TREG: `Carta regalo`,
    },
  },
  whatsapp: {
    title: `Accesso esclusivo a WhatsApp Business`,
    body: `Per utilizzare la funzione WhatsApp Business è necessario un abbonamento WhatsApp Business Personal attivo. Questa opzione è pensata per offrirti strumenti aggiuntivi e funzionalità avanzate per potenziare l'esperienza della tua attività.`,
  },
  nav: {
    welcome: `Benvenuto`,
    manager: `Manager`,
    logout: `Esci`,
    logoutError: `Spiacenti, si è verificato un errore durante la disconnessione`,
  },
  subnav: {
    home: `Home`,
    clients: `Clienti`,
    prices: `Prezzi`,
    payments: `Pagamenti`,
    userManagement: `Gestione utenti`,
  },
};
